
import formularmodal from '~/mixins/formularmodal';
export default {
  mixins: [formularmodal],
  props: [],
  data() {
    return {
      modal: {
        event: ['display::maschine-auftraege', 'display::anbaugeraet-auftraege'],
        titel: 'Letzte Aufträge',
        modelname: 'Auftrag',
        model: 'auftraege'
      },
      model: null
    }
  },
  computed: {},
  watch: {},
  methods: {
    nachStart() {
      let filter = [];
      if (this.params.maschine) filter.push({where: ['maschine_id', '=', this.params.maschine.id]});
      if (this.params.anbaugeraet) filter.push({where: ['anbaugeraet_id', '=', this.params.anbaugeraet.id]});
      this.$$fill('auftraege', {
        filter: filter,
        with: ['betrieb', 'maschine', 'anbaugeraet', 'pflanzenschutzmittel'],
        orderBy: {'datum': 'desc'}
      });
      this.$$abrufen('auftraege');
    }
  },

}
